import { Form, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getUser } from 'utils/auth';

import authApi from 'api/authApi';
import { logout } from 'features/auth/authSlice';
import { passwordChange } from 'features/auth/passwordAction';
import { useDispatch } from 'react-redux';

import PasswordItem from 'features/auth/components/PasswordItem';
import {
  ButtonStyled,
  ContentStyled,
  TextStyled,
  TitleStyled,
} from 'features/auth/pages/SignUp/styled';

const PasswordChange = (props: any) => {
  const { isVisible, onClose, isPassword } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation(['auth', 'validation', 'modal', 'header']);
  const [form] = Form.useForm();

  const [messageError, setMessageError] = useState('');

  const onChangePassword = () => {
    form
      .validateFields()
      .then((success) => {
        dispatch(
          passwordChange({
            userId: getUser().id,
            data: isPassword
              ? {
                  oldPass: success?.oldPass,
                  newPass: success?.newPass,
                  isPassword: true,
                }
              : {
                  newPass: success?.newPass,
                  isPassword: false,
                },
            callBack: (response: any) => {
              if (!response?.error || response?.statusCode === 200) {
                Modal.info({
                  title: isPassword
                    ? t('auth:password.password_change_successful')
                    : t('auth:password.password_create_successful'),
                  onOk: () => {
                    authApi.logout(getUser().id);
                    dispatch(logout());
                    localStorage.removeItem('current_date_choose');
                  },
                });
              } else {
                setMessageError(response?.error?.message);
              }
            },
          }),
        );
      })
      .catch((error) => {
        console.log('Validate error', error);
        Modal.error({ title: t('modal:error_try_again') });
      });
  };

  const handleClose = () => {
    setMessageError('');
    onClose();
  };

  return (
    <Modal
      visible={isVisible}
      maskClosable={false}
      onCancel={handleClose}
      style={{ top: 20 }}
      footer={null}
    >
      <ContentStyled>
        <TitleStyled className="medium">
          {isPassword ? t('auth:password.change_password_title') : t('header:create_password')}
        </TitleStyled>
        <TextStyled className="small error">{messageError}</TextStyled>
        <PasswordItem formData={form} isChangePassword={isPassword} />
        <ButtonStyled onClick={onChangePassword}>
          {isPassword ? t('auth:password.btn_change_password') : t('header:create_password')}
        </ButtonStyled>
      </ContentStyled>
    </Modal>
  );
};

export default PasswordChange;
